// Copyright (c) Docugami, Inc. All rights reserved.

import { TokenRange } from "networking/api";
import { Component, ComponentId, ComponentProps } from "sdv/engine/Component";
import { TokenRangeBox } from "./TokenLinesComponent";
import { TokenRangeInfoComponent } from "./TokenRangeInfoComponent";

export enum TokenSnapBehavior {
    Token,
    TokenLine,
    Hyperline
}

export interface ResizeComponent extends Component {
    typeId: ComponentId.Resize;
    // Set when resizing with grab handles or creating a new chunk with the highlighter
    isResizing?: boolean;
    // Set when creating a new chunk with the highlighter
    isCreating?: boolean;
    // List of resize operations that have occurred (n-1 is latest operation)
    ops: ResizeOp[];
    // Desired snap behavior for the interation
    snapBehavior: TokenSnapBehavior;
    // Flag indicating whether the fromTok is the one being modified
    isFromTok?: boolean;
    // Token hit result for the current frame during an active resize operation
    hitResult?: TokenHitResult;
    // Color used for primary selection while resizing
    primaryColor?: string;
    // Color used for selection hints while resizing
    secondaryColor?: string;
}

export interface TokenHitResult {
    token: number;
    line: TokenRangeBox;
    tokenHyperlineId?: string;
    tokenLineHyperlineId?: string;
}

export interface ResizeOp {
    tokenRange: TokenRange;
    info: ComponentProps<TokenRangeInfoComponent>;
    snapBehavior?: TokenSnapBehavior;
    isFromTok?: boolean;
}
